import React, {useEffect, useState} from 'react';
import {Button, Divider, Select, Space} from "antd";
import {getAllCustomerSearch} from "../../../../api/customer";
import AddCustomerParent from "../modal/addCustomerParent";
import {vnNormalize} from "../../../canMobile/weighing-slip/common/vnNormalize";

const DG_Select_Customer = (props) => {
    const [customers, setCustomers] = useState([]);
    const {Option} = Select;

    const [visible, setVisible] = useState(false)

    useEffect(() => {
        getAllCustomerSearch(null).then(r => {
            setCustomers(r)
        })
            .catch(()=>{})
    }, [])

    /*const fetchRef = useRef(0);
    const debounceFetcher = useMemo(() => {
        const loadOptions = (search) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            getAllCustomerSearch(search).then((response) => {
                    if (fetchId !== fetchRef.current) {
                        return;
                    }
                    setCustomers(response)
                }
            )
                .catch(()=>{})
        };

        return debounce(loadOptions, 400);
    }, [400]);*/

    function getCustomer() {
        return customers?.map((item) => (
            <Option key={item.id} value={item.id}> {item.customerName} </Option>
        ))
    }

    function NotFoundContent() {
        return (
            <div className={"text-center text-black py-[30px] px-[40px]"}>
                <p className={"mb-2 font-[600] leading-[24px]"}>Không tìm thấy</p>
                <p className={"text-[14px] font-[400] leading-[20px]"}>Hãy thay đổi từ khóa và thử lại</p>
            </div>
        );
    }

    return (
        <>
            <Select
                placeholder={"Nhập khách hàng"}
                showSearch
                // filterOption={false}
                // onSearch={debounceFetcher}
                filterOption={(input, option) =>
                    vnNormalize(option.props.children[1].toLowerCase()).indexOf(input.toLowerCase()) >= 0
                    || option.props.children[1].toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                notFoundContent={<NotFoundContent/>}
                style={{
                    width: '100%',
                }}
                optionValueProp
                dropdownRender={(menu) => (
                    <>
                        {menu}
                        <Divider
                            style={{
                                margin: '8px 0',
                            }}
                        />
                        <Space
                            style={{
                                padding: '0 8px 4px',
                            }}
                        >
                            <Button type="link" style={{color: "#1890FF"}} onClick={() => setVisible(true)}>
                                Thêm như môt khách hàng mới
                            </Button>
                        </Space>
                    </>
                )}
                {...props}
            >
                {getCustomer()}
            </Select>

            <AddCustomerParent visible={visible}
                               onCancel={(value) => setVisible(value)}
                               onCustomers={(value) => {
                                   setCustomers([value])
                                   props.form.setFieldsValue({customerId: Number(value.id)})
                               }}/>
        </>
    );
};

DG_Select_Customer.propTypes = {};

export default DG_Select_Customer;
